<div role="banner" class="mdk-app-footer" style="min-height: 60px;">
  <div class="js-vl-accordion">
    <div class="vl-toggle-wrapper--more-button">
      <button class="vl-toggle vl-toggle--more-button js-vl-accordion__toggle" #accordion>
        <i class="vl-toggle__icon vl-vi vl-vi-arrow-down-fat" aria-hidden="true"></i>
      </button>
    </div>
    <div class="vl-accordion__content">
      <div class="vl-accordion__panel">
        <div class="mdk-app-footer__container">
          <div class="mdk-app-footer__logo">
            <img src="vlaanderen-logo-footer.svg" alt="logo Vlaanderen" class="mdk-app-footer__logo__image" />
          </div>
      
          <div class="mdk-app-footer__body">
            <div>
              <h2 class="mdk-app-footer__body__title">
                {{title}} is een officiële website van de Vlaamse overheid
      
                <div class="mdk-app-footer__body__subtitle">
                  uitgegeven door
                  <a href="https://afdelingkust.be/" target="_blank"
                    class="mdk-app-footer__body__subtitle__link">afdelingkust.be</a>
                </div>
              </h2>
            </div>
      
            <ul class="mdk-app-footer__body__links">
              <li class="mdk-app-footer__body__links__item">
                <a href="https://afdelingkust.be/nl/privacyverklaring" target="_blank"
                  class="mdk-app-footer__body__links__item__link">Privacyverklaring</a>
              </li>
      
              <li class="mdk-app-footer__body__links__item">
                <a href="https://afdelingkust.be/nl/cookiebeleid" target="_blank"
                  class="mdk-app-footer__body__links__item__link">Cookiebeleid</a>
              </li>
              <li class="mdk-app-footer__body__links__item">
                <a href="https://www.agentschapmdk.be/nl/algemene-voorwaarden" target="_blank"
                  class="mdk-app-footer__body__links__item__link">Algemene voorwaarden</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
